var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.003.207a1.945 1.945 0 0 0-1.746 0L1.644 8.04A1.959 1.959 0 0 0 .565 9.792v11.75c0 5.213 1.68 9.579 4.69 13.152 2.979 3.536 7.185 6.211 12.136 8.244a1.945 1.945 0 0 0 1.478 0c4.95-2.033 9.157-4.708 12.136-8.244 3.01-3.573 4.69-7.939 4.69-13.152V9.792c0-.742-.418-1.42-1.08-1.752L19.002.207ZM4.468 21.542v-10.54L18.13 4.148l13.661 6.854v10.54c0 4.293-1.356 7.762-3.767 10.624-2.31 2.742-5.655 5.004-9.894 6.836-4.24-1.832-7.584-4.094-9.894-6.836-2.411-2.862-3.768-6.33-3.768-10.624Zm22.946-4.596a1.963 1.963 0 0 0-.203-2.762 1.947 1.947 0 0 0-2.752.204l-8.744 10.169-4.025-3.961a1.947 1.947 0 0 0-2.76.026 1.963 1.963 0 0 0 .027 2.77l5.51 5.423a1.948 1.948 0 0 0 2.844-.119l10.103-11.75Z",
    fill: "#fff"
  })));
};
export default SvgShield;